module.exports = __webpack_public_path__ + "assets/gov-orange-lg-logo-dbbfb9.svg";